import { render, staticRenderFns } from "./DesignBaseProgress.vue?vue&type=template&id=0a8b0e88&"
import script from "./DesignBaseProgress.vue?vue&type=script&lang=js&"
export * from "./DesignBaseProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports